module.exports = __webpack_public_path__ + "static/assets/a80276dd94311948998750d3a9815787.png";